export function getCompanyNameValidationError(name: string): string | null {
    const trimmedName = name.trim()

    if (!trimmedName) {
        return 'Nome azienda è obbligatorio'
    }

    // In fase di prescriptions/store, PrimoUp costruisce l'email della clinica
    // a partire dal nome società (togliendo gli spazi). Se questo "local part"
    // non è un'email valida, lo store fallisce. Blocchiamo qui i casi che la
    // rompono e chiediamo all'utente di correggere il nome.
    const emailLocalPart = trimmedName.replace(/\s+/g, '')

    if (/[^A-Za-z0-9._-]/.test(emailLocalPart)) {
        return "Il nome contiene caratteri non ammessi (es. & @ / o lettere accentate). Usa solo lettere non accentate, numeri, punti o trattini."
    }

    if (/^[._-]/.test(emailLocalPart) || /[._-]$/.test(emailLocalPart)) {
        return "Il nome non può iniziare o finire con punto, trattino o underscore (es. \"S.r.l.\" → scrivi \"Srl\")."
    }

    if (/\.\./.test(emailLocalPart)) {
        return 'Il nome non può contenere due punti consecutivi.'
    }

    return null
}

export function toPrimoUpSlug(value: string): string {
    return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .replace(/-+/g, '-')
}

function toEmailLocalPart(value: string): string {
    const normalized = value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '.')
        .replace(/^\.+|\.+$/g, '')
        .replace(/\.{2,}/g, '.')
        .slice(0, 64)
        .replace(/\.+$/g, '')

    return normalized || 'paziente'
}

export function buildPrimoUpCustomerEmail(
    patientName: string,
    companySlug: string | null,
    companySuffix: string,
): string {
    const safeDomain = (
        toPrimoUpSlug(companySlug ?? '') ||
        toPrimoUpSlug(companySuffix) ||
        'clinica'
    )
        .slice(0, 63)
        .replace(/-+$/g, '')

    return `${toEmailLocalPart(patientName)}@${safeDomain}.it`
}
